export default "/_next/static/images/27/children-27c17bfaaacb41ed45299051b8fee7e5.png";